import { render, staticRenderFns } from "./BlogForm.vue?vue&type=template&id=6a1d23cf&scoped=true"
import script from "./BlogForm.vue?vue&type=script&lang=js"
export * from "./BlogForm.vue?vue&type=script&lang=js"
import style0 from "./BlogForm.vue?vue&type=style&index=0&id=6a1d23cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1d23cf",
  null
  
)

export default component.exports